
const constants = {
    LOVS_LANGUAGE: 'LOVS_LANGUAGE',
}

export default constants